import { render, staticRenderFns } from "./TambahPegawai.vue?vue&type=template&id=022a196f&scoped=true"
import script from "./TambahPegawai.vue?vue&type=script&lang=js"
export * from "./TambahPegawai.vue?vue&type=script&lang=js"
import style0 from "./TambahPegawai.vue?vue&type=style&index=0&id=022a196f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a196f",
  null
  
)

export default component.exports